const cactusManiaImg = require('../images/cactusMania.png');
const cactusManiaVideo = require('../images/video/Cactus-Mania.mp4');
const gifBoxImg = require('../images/GifBox.png');
const gifBoxVideo = require('../images/video/Gif-Box.mp4');
const pigDiceImg = require('../images/pig-dice.png');
const pigDiceVideo = require('../images/video/Pig-Dice.mp4');

module.exports = {
    projects: [
        {
            id: 1,
            name: "Pig Dice",
            img: pigDiceImg,
            video: pigDiceVideo,
            githubLink: "https://github.com/SheW0lf/Pig-Dice",
            description: "This is a simple dice game built in JavaScript. The purpose of this project was to develop an interactive game with vanilla JS, incorporating more advanced JavaScript and Sass styling techniques",
            stack: [
                {
                    type: 'html5',
                    name: 'HTML'
                },
                {
                    type: "sass",
                    name: 'Sass'
                },
                {
                    type: 'js',
                    name: 'JavaScript'
                }

            ]
        },
        {
            id: 2,
            name: "Gif Box",
            img: gifBoxImg,
            video: gifBoxVideo,
            githubLink: "https://github.com/SheW0lf/GifBox",
            description: "This web application was built using the Giphy API. The goal of the project was to incorporate data from an external API and render it using the React.js library. Each gif card also contains the HTML and IFrame links so the gif can be embeded into external sites for use as well.",
            stack: [
                {
                    type: 'html5',
                    name: 'HTML'
                },
                {
                    type: "sass",
                    name: 'Sass'
                },
                {
                    type: 'js',
                    name: 'JavaScript'
                },
                {
                    type: 'react',
                    name: 'React'
                }

            ]
        },
        {
            id: 3,
            name: "Cactus Mania",
            img: cactusManiaImg,
            video: cactusManiaVideo,
            githubLink: "https://github.com/SheW0lf/cactus_mania",
            description: "This site was designed for a fictional cactus blog. The goal of the project was to practice implementing advanced styling techniques using the CSS preprocessor Sass without the use of JavaScript. Unfortunately, to implement some menu functionality, a small script had to be written, but over 99% of the functionality is purely CSS.",
            stack: [
                {
                    type: 'html5',
                    name: 'HTML'
                },
                {
                    type: "sass",
                    name: 'Sass'
                },
                {
                    type: 'js',
                    name: 'JavaScript'
                }

            ]
        },
    ]
}



// WEBPACK FOOTER //
// ./src/js/data.js